import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { preventDefaultHandler } from '@/helpers'
import { useEmailState } from './hooks'
import css from './styles.module.css'

interface Props {
  initial: string
  onSubmit: (value: string) => void
}

export const EmailInput: React.FC<Props> = ({ initial, onSubmit }) => {
  const { ref, state, handleKeyUp, handleSubmit, onChange, disabled } =
    useEmailState(initial, onSubmit)

  return (
    <div className={css.row}>
      <div className={css.title}>Email</div>
      <div className={css.input_wrap}>
        <input
          ref={ref}
          value={state}
          className={css.input}
          onChange={onChange}
          onKeyUp={handleKeyUp}
        />

        <Button
          className={css.button}
          size="xxsmall"
          label="Ok"
          disabled={disabled}
          onMouseDown={preventDefaultHandler}
          onClick={handleSubmit}
        />
      </div>
    </div>
  )
}
